module.exports = __webpack_public_path__ + "img/step-two.47bdb887.jpg";